export enum SearchResultType
{
    Customer = 0,
    Project = 1,
    Invoice = 2
}